module.exports = __webpack_public_path__ + "images/huazhu3.jpg?v=3fbd28c4";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/index/huazhu3.jpg
 ** module id = 108
 ** module chunks = 1 2
 **/